/**
 * Environment helpers derived from the build's Firebase config.
 *
 * Every build targets exactly one Firebase project (see .env.development,
 * .env.staging, .env.production). Use these helpers instead of hardcoding
 * project IDs or Cloud Functions URLs, so a dev build never talks to production.
 */

export const PROD_PROJECT_ID = 'the-journey-perimeter'

export const FIREBASE_PROJECT_ID =
  process.env.VUE_APP_FIREBASE_PROJECT_ID || PROD_PROJECT_ID

/** 'production' | 'staging' | 'development' */
export const APP_ENV =
  process.env.VUE_APP_ENV ||
  (FIREBASE_PROJECT_ID === PROD_PROJECT_ID ? 'production' : 'development')

export const IS_PRODUCTION =
  APP_ENV === 'production' && FIREBASE_PROJECT_ID === PROD_PROJECT_ID

export const FUNCTIONS_BASE_URL = `https://us-central1-${FIREBASE_PROJECT_ID}.cloudfunctions.net`

/** Full URL for an HTTPS Cloud Function in this build's project. */
export function functionUrl(name) {
  return `${FUNCTIONS_BASE_URL}/${String(name).replace(/^\/+/, '')}`
}
